document.addEventSelectorListener("click", "[data-roll]", function(event, target) {
	event.preventDefault();

	const element = document.querySelector(target.getAttribute("data-roll"));
	element.classList.toggle("expanded");
});
